module.exports = __webpack_public_path__ + "img/Group8.0cdac024.svg";